export const PATIENT_ON_HOLD_DEFAULT_SORT = {
  sortedColumn: 'startDate',
  sortedColumnOrder: 'descend'
}

export const PATIENT_RPM_BILLABLE_DEFAULT_SORT = {
  sortedColumn: 'createdAt',
  sortedColumnOrder: 'descend'
}
